const moment = require("moment");

import UserStatus from './component/UserStatus';
import UserList from './component/UserList';
import UserSearch from './component/UserSearch';

export default {
  name:'userManagement',
  components: {
    UserStatus,
    UserList,
    UserSearch,
  },
  data() {
    return {
      fullDate: [],
      fullUptDate: [],
      queryParams: {
        name: '',
        ageRange: [],
        letter_yn: [],
        gender: [],
        grade: [],
        pannel: [],
        industry_key: [],
        authority: [],
        user_status: [],
        employee : [],
      },
      /////////////////////////////////////////////////////////////////////////////////////////////
      userDetailInfo:{user_id:''},
    }
  },
  watch: {
  },
  mounted: function() {
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/user/userList/userManagement.js